const titleConfig = {
  'ql-bold': '加粗',
  'ql-color': '颜色',
  'ql-font': '字体',
  'ql-code': '插入代码',
  'ql-italic': '斜体',
  'ql-link': '添加链接',
  'ql-background': '背景颜色',
  'ql-size': '字体大小',
  'ql-strike': '删除线',
  'ql-script': '上标/下标',
  'ql-underline': '下划线',
  'ql-blockquote': '引用',
  'ql-header': '标题',
  'ql-indent': '缩进',
  'ql-list': '列表',
  'ql-align': '文本对齐',
  'ql-direction': '文本方向',
  'ql-code-block': '代码块',
  'ql-formula': '公式',
  'ql-image': '图片',
  'ql-clean': '清除字体样式',
  'ql-upload': '文件'
};

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ font: [] }], // 字体种类-----[{ font: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
  ["link", "image"] // 链接、图片、视频-----['link', 'image', 'video']
];

const qiniu = require('qiniu-js');

export default {
  props: {},
  data() {
    let that = this
    return {
      QiniuToken: "",
      detailFileList: [],
      currDetailFileList: [],
      beforeArr: [],
      sArr: [],
      maxlegth: 0,
      length: 0,
      inx: [],
      lastRequestId: 0,
      lastResponse: null,
      uniqueId: "uniqueId",
      content: "<h2>I am Example</h2>", // 富文本编辑器默认内容
      loading: false,
      imgurl: "",
      editorOption: {
        theme: "snow",
        placeholder: "请输入正文",
        modules: {
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                if (value) {
                  // 调用iview图片上传
                  document.querySelector('.bottom .el-upload.el-upload--picture-card ').click()
                  console.log('我点了')
                  that.beforeArr = []
                  that.$refs.uploadicon.clearFiles();
                  that.currDetailFileList = [];
                } else {
                  this.quill.format('image', false);
                }
              }
            }
          }
        }
      },
    }
  },
  computed: {},
  mounted() {
    this.getQiniuToken()
    this.addQuillTitle()
    console.log(777)
    // this.$refs.uploadicon.clearFiles();
  },
  created() {
    // this.$refs.uploadicon.clearFiles();
  },
  methods: {
    beforeUpload(file) {
      this.beforeArr.push(file);
      this.currDetailFileList.push({});
    },
    uploadFile(file) {
      let fileIndex = this.detailFileList.findIndex(item => item.uid === file.file.uid);
      const isJPG = file.type === 'image/jpeg' || 'image/jpg'
      const isPNG = file.type === 'image/png'
      if (!isPNG && !isJPG) {
        this.currDetailFileList[fileIndex].status = 'error';
        this.currDetailFileList[fileIndex].errorMsg = '上传图片只能是 JPG/PNG/JPEG 格式!';
        this.checkErrorFile(fileIndex);
        this.checkSuccessFile(this.currDetailFileList.length - 1);
        return false
      }

      const isLt8M = file.file.size / 1024 / 1024 < 8
      if (!isLt8M) {
        this.currDetailFileList[fileIndex].status = 'error';
        this.currDetailFileList[fileIndex].errorMsg = '上传图片单张大小不能超过 8MB!';
        this.checkErrorFile(fileIndex);
        this.checkSuccessFile(this.currDetailFileList.length - 1);
        return false
      }

      const putExtra = {
        fname: "",//文件原文件名
        params: {},//用来放置自定义变量
        mimeType: ["image/png", "image/jpeg", "image/gif"],//用来限定上传文件类型，指定null时自动判断文件类型。
      }
      const config = {
        useCdnDomain: true,//表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
        forceDirect: true, // 强制选择直传
      }
      console.log('qiniu:>>', qiniu, qiniu.upload)
      const key = "internalSystem/" + this.generateUUID();
      const observable = qiniu.upload(file.file, key, this.QiniuToken, putExtra, config)
      let thiz = this
      const subscription = observable.subscribe({
        next(res) {
          // console.log('next>>', res)
        },
        error(err) {
          thiz.currDetailFileList[fileIndex].status = 'error';
          thiz.currDetailFileList[fileIndex].errorMsg = '网络原因，建议减少上传张数或总大小。';
          thiz.checkErrorFile(fileIndex);
          thiz.checkSuccessFile(this.currDetailFileList.length - 1);
        },
        complete(res) {
          thiz.handleSuccess1(key, file)
        },
      })
    },
    handleSuccess1(key, file) {
      let fileIndex = this.detailFileList.findIndex(item => item.uid === file.file.uid);
      if (fileIndex === -1) {
        // 已经是下一次点击了
        return;
      }
      this.currDetailFileList[fileIndex].url = this.ImgHttps + key;
      this.currDetailFileList[fileIndex].status = 'waiting';

      // 把其他上传成功的图片插入
      this.checkSuccessFile(this.currDetailFileList.length);
    },
    checkSuccessFile(fileIndex) {
      // 检查是否有上传成功但未插入的图片，插入到编辑器中
      for (let i = 0; i < fileIndex; i++) {
        if (!this.currDetailFileList[i]) {
          // 还没上传成功
          return false;
        }
        if (this.currDetailFileList[i].status !== 'success' && this.currDetailFileList[i].status !== 'waiting') {
          if (this.currDetailFileList[i].status === 'error' && this.currDetailFileList[i].errorMsg) {
            this.$message.error(this.currDetailFileList[i].errorMsg)
            this.currDetailFileList[i].errorMsg = undefined;
          }
          return false;
        }
        if (this.currDetailFileList[i].status === 'waiting') {
          this.insertImage(this.currDetailFileList[i].url);
          this.currDetailFileList[i].status = 'success';
        }
      }
      return true;
    },
    checkErrorFile(fileIndex) {
      // 检查是否还有未上传成功的图片,只提示第一个错误
      for (let i = 0; i < fileIndex; i++) {
        if (!this.currDetailFileList[i]) {
          // 还没上传成功
          return false;
        }
        if (this.currDetailFileList[i].status !== 'success' && this.currDetailFileList[i].status !== 'waiting') {
          return false;
        }
      }
      this.$message.error(this.currDetailFileList[fileIndex].errorMsg)
      this.currDetailFileList[fileIndex].errorMsg = undefined;
      return true;
    },
    insertImage(imageUrl) {
      let quill = this.$refs.myQuillEditor.quill
      // 获取光标所在位置
      let length = quill.getSelection().index;
      // 插入图片，res为服务器返回的图片链接地址
      quill.insertEmbed(length, 'image', imageUrl);
      // 调整光标到最后
      quill.setSelection(length + 1)
    },
    handleChange(file, fileList) {
      this.detailFileList = fileList
    },
    // 获取七牛token
    getQiniuToken() {
      this.axios.post('/sys/v1/common/upload/ossToken').then(res => {
        console.log('>>', res)
        if (res.code === 0) {
          this.QiniuToken = res.data
        }
      })
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    // 鼠标hover提示
    addQuillTitle() {
      const oToolBar = document.querySelector('.ql-toolbar'),
        aButton = oToolBar.querySelectorAll('button'),
        aSelect = oToolBar.querySelectorAll('select');
      aButton.forEach(function (item) {
        if (item.className === 'ql-script') {
          item.value === 'sub' ? item.title = '下标' : item.title = '上标';
        } else if (item.className === 'ql-indent') {
          item.value === '+1' ? item.title = '向右缩进' : item.title = '向左缩进';
        } else {
          item.title = titleConfig[item.classList[0]];
        }
      });
      aSelect.forEach(function (item) {
        item.parentNode.title = titleConfig[item.classList[0]];
      });
    },
  }
}

